import React from "react";
import style from "./proyects.module.scss";
import ProyectCard from "../../commons/proyectCard/ProyectCard";
import Paginacion from "../../commons/pagination/Paginacion";
import { AnimationOnScroll } from "react-animation-on-scroll";

function ProyectsComponent({ props }) {
  const { list, animacion } = props;
  return (
    <div className={style.container}>
      <div className={style.proyects}>
        <h2>
          <span className={style.subrayado}>PROYECT</span>OS
        </h2>
      </div>
      <AnimationOnScroll
        className={style.cardContainer}
        animateIn="animate__zoomInRight"
        animateOnce={true}
        duration={1.7}
      >
        {list.map((project, i) => (
          <ProyectCard key={i} data={{ proyecto: project }} />
        ))}
      </AnimationOnScroll>
      <div>
        <Paginacion data={props} />
      </div>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path
          fill="#101011"
          fillOpacity="1"
          d="M0,160L40,176C80,192,160,224,240,224C320,224,400,192,480,192C560,192,640,224,720,229.3C800,235,880,213,960,181.3C1040,149,1120,107,1200,106.7C1280,107,1360,149,1400,170.7L1440,192L1440,320L1400,320C1360,320,1280,320,1200,320C1120,320,1040,320,960,320C880,320,800,320,720,320C640,320,560,320,480,320C400,320,320,320,240,320C160,320,80,320,40,320L0,320Z"
        ></path>
      </svg>
    </div>
  );
}

export default ProyectsComponent;
